(function() {
  'use strict';
  
  // Run on both mobile and desktop for the products collection
  function initAutoScroll() {
    // Check if this is the products collection page
    if (!window.location.pathname.includes('/collections/products')) return;
    
    // Wait for the page to be fully loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', performScroll);
    } else {
      performScroll();
    }
  }
  
  function performScroll() {
    // Small delay to ensure everything is rendered
    setTimeout(function() {
      // Find the product grid container
      const productGrid = document.querySelector('.product-grid-container');
      if (!productGrid) return;
      
      // Different scroll distances for mobile vs desktop
      const isMobile = window.innerWidth <= 749;
      const scrollDistance = isMobile ? 100 : 200; // Bigger scroll for desktop
      
      // Smooth scroll down
      window.scrollTo({
        top: scrollDistance,
        behavior: 'smooth'
      });
    }, 300); // 300ms delay to ensure page is fully rendered
  }
  
  // Initialize when the script loads
  initAutoScroll();
})();